import React from "react";
import { Row, Col } from "reactstrap";
import { CFormLabel, CFormInput } from "@coreui/react";
import DatePicker from "react-datepicker";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function CreateAPLPeriodGeneral({
  aplName,
  aplStartDate,
  aplEndDate,
  aplHoursPerWeek,
  aplDaysPerWeek,
  handleSetDaysPerWeek,
  handleSetHoursPerWeek,
  handleSetName,
  handleSetStartDate,
  handleSetEndDate,
  setAplValidationErrors,
  aplValidationErrors,
}) {
  const validateName = (data) => {
    if (data.target.value === "") {
      setAplValidationErrors([...aplValidationErrors, "aplName"]);
    } else {
      setAplValidationErrors(
        aplValidationErrors.filter((item) => item !== "aplName")
      );
      handleSetName(data.target.value);
    }
  };

  const validateDate = (date, startOrEnd) => {
    if (date === "") {
      setAplValidationErrors([...aplValidationErrors, "aplDate"]);
    } else {
      setAplValidationErrors(
        aplValidationErrors.filter((item) => item !== "aplDate")
      );
      if (startOrEnd === "start") {
        handleSetStartDate(date);
      } else {
        handleSetEndDate(date);
      }
    }
  };
  /***********Commented until furher notice, when implemented uncomment*************/
  /* const validateAplHoursPerWeek = (data) => {
    if (data === "") {
      setAplValidationErrors([...aplValidationErrors, "aplHoursPerWeek"]);
    } else {
      setAplValidationErrors(
        aplValidationErrors.filter((item) => item !== "aplHoursPerWeek")
      );
      handleSetHoursPerWeek(data);
    }
  };

  const validateAplDaysPerWeek = (data) => {
    if (data === "") {
      setAplValidationErrors([...aplValidationErrors, "aplDaysPerWeek"]);
    } else {
      setAplValidationErrors(
        aplValidationErrors.filter((item) => item !== "aplDaysPerWeek")
      );
      handleSetDaysPerWeek(data);
    }
  }; */

  return (
    <Col>
      <Row style={{ alignItems: "baseline" }}>
        <Col lg={3}></Col>
        <Col lg={9}>
          <span className="text-warning">
            <FontAwesomeIcon
              icon="triangle-exclamation"
              style={{ marginRight: "0.1rem" }}
            />
          </span>
          <span className="font-italic">
            <FormattedMessage id="ConsiderUsingANameThatCanBeFoundLater" />.
          </span>
        </Col>
      </Row>
      <Row style={{ alignItems: "baseline" }}>
        <Col lg={3}>
          <CFormLabel htmlFor="className">
            <FormattedMessage id="Name" />:{" "}
          </CFormLabel>
        </Col>
        <Col lg={9}>
          <CFormInput
            type="text"
            id="aplName"
            name="aplName"
            defaultValue={aplName !== "" ? aplName : ""}
            placeholder="Namn på period"
            autoComplete="false"
            onChange={(data) => validateName(data)}
          />
          {aplValidationErrors.some((item) => item === "aplName") ? (
            <p className="text-danger">
              <FormattedMessage id="Views.Admin.Module.NameIsRequired" />
            </p>
          ) : (
            ""
          )}
        </Col>
      </Row>
      <Row className="mb-3"></Row>
      <Row style={{ marginBottom: "1rem", alignItems: "baseline" }}>
        <Col lg={3}>
          <label>
            <FormattedMessage id="Period" />:
          </label>
        </Col>
        <Col lg={9}>
          <DatePicker
            wrapperClassName="d-block"
            selectsRange
            startDate={aplStartDate}
            endDate={aplEndDate}
            onChange={([start, end]) => {
              validateDate(start, "start");
              validateDate(end, "end");
            }}
            minDate={new Date()}
            dateFormat="yyyy-MM-dd"
            locale="sv"
            className="form-control text-center"
            placeholderText="från – till"
          />

          {aplValidationErrors.some((item) => item === "aplDate") ? (
            <p className="text-danger">
              <FormattedMessage id="StartAndEndDateIsRequiredForPeriod" />
            </p>
          ) : (
            ""
          )}
        </Col>
      </Row>
      {/***********Commented until furher notice, when implemented uncomment*************/}
      {/* <Row style={{ marginBottom: "1rem", alignItems: "baseline" }}>
        <Col lg={3}>
          <CFormLabel htmlFor="className">
            <FormattedMessage id="HoursPerWeek" />:{" "}
          </CFormLabel>
        </Col>
        <Col lg={9}>
          <CFormInput
            type="number"
            id="aplHoursPerWeek"
            name="aplHoursPerWeek"
            defaultValue={aplHoursPerWeek !== null ? aplHoursPerWeek : null}
            onBlur={(data) => validateAplHoursPerWeek(data.target.value)}
            placeholder="Antal timmar per vecka..."
            autoComplete="false"
          />
          {aplValidationErrors.some((item) => item === "aplHoursPerWeek") ? (
            <p className="text-danger">
              <FormattedMessage id="HoursPerWeekIsRequired" />
            </p>
          ) : (
            ""
          )}
        </Col>
      </Row>
      <Row style={{ marginBottom: "1rem", alignItems: "baseline" }}>
        <Col lg={3}>
          <CFormLabel htmlFor="className">
            <FormattedMessage id="DaysPerWeek" />:{" "}
          </CFormLabel>
        </Col>
        <Col lg={9}>
          <CFormInput
            type="number"
            id="aplDaysPerWeek"
            name="aplDaysPerWeek"
            defaultValue={aplDaysPerWeek !== null ? aplDaysPerWeek : null}
            onBlur={(data) => validateAplDaysPerWeek(data.target.value)}
            placeholder="Antal dagar per vecka..."
            autoComplete="false"
          />
          {aplValidationErrors.some((item) => item === "aplDaysPerWeek") ? (
            <p className="text-danger">
              <FormattedMessage id="DaysPerWeekIsRequired" />
            </p>
          ) : (
            ""
          )}
        </Col>
      </Row> */}
    </Col>
  );
}
